import React, { Component } from 'react';

import Api from '../../../api/Api';

import moment from 'moment';

import Loader from '../../../components/Loader';

import EmployementItem from './EmployementItem';

import { Form, Select, Input, DatePicker, Button, Carousel } from 'antd';

class Employement extends Component { 
    constructor(props) {
        super();
        this.state = {
            loading: false,
            list: [],

            remove_loading: false,
            item: false
        }
    }

    componentDidMount = () => {

        window.setTimeout(() => {
            this.loadEmployementList(this.props.account_token);
        });
    }

    render () {

        return (

            <>

                {this.props.account_token &&

                    <div style={{position:'relative'}}>
                        <div className="custom-carousel custom-employment-carousel">
                            <Carousel arrows={true}>

                                {this.state.list.length > 0 &&

                                    this.state.list.map((emp_item, index) => {

                                        return <EmployementItem
                                                    editable={true}
                                                    key={'emp_item_' + emp_item.id}
                                                    index={index}
                                                    emp_item={emp_item}
                                                    editItem={(item) => {

                                                        this.editItem(item)
                                                    }}
                                                    remove={(item) => {

                                                        this.remove(item)
                                                    }}
                                                />
                                    })
                                }
                                
                            </Carousel>

                        </div>
                        {this.state.remove_loading &&
                            <Loader />
                        }
                    </div>
                }
                {this.props.display
                    ?
                        this.employmentForm()
                    :
                        null
                }
            </>
        )
    }

    onEmployementSubmit = (values) => {
        var formData = new FormData();
        formData.append('account_token', this.props.account_token);

        if(this.state.item != false){

            formData.append('item_id', this.state.item.id);
        }

        Object.keys(values).forEach((key) => {

            if(values[key]){
                formData.append(key, values[key])
            }
        });
        
        var that = this;

        this.setState({loading: true});
        Api.post('freelancer/profile_update_employement', formData, function(data){
            
            that.setState({loading: false, item: false});
            
            if(data.status == true){
            
                that.setState({list: data.list});
                that.props.hide_form();
                that.props.updateUser(data.user);
            
            }else{
                that.props.onError(data.message);
            }
        });
    }

    employmentForm = () => {

        const layout = {
            labelCol: { span: 24 },
            wrapperCol: { span: 24 },
        };

        const validateMessages = {
            required: '${label} is required!',
            types: {
                email: '${label} is not valid!',
                number: '${label} is not a valid number!',
            },
            number: {
              range: '${label} must be between ${min} and ${max}',
            },
        };

        return (

            <div className={"table-row table-row-employment-form"}>
            
                <Form {...layout} scrollToFirstError={true} name="update_employment_details" ref="update_employment_details" validateMessages={validateMessages} onFinish={this.onEmployementSubmit.bind(this)}>
                    <div className="d-flex form-item-block">
                        
                        <Form.Item className="w-50" label="Company Name" name={"company_name"} rules={[{required:true}]}>
                            <Input />
                        </Form.Item>
                        <Form.Item className="w-50" label="Title" name={"title"} rules={[{required:true}]}>
                            <Input />
                        </Form.Item>
                    </div>

                    <div className="d-flex form-item-block">
                        <div className="d-flex justify-content-between w-50">
                            <Form.Item className="w-50" label="From" name={"from"} rules={[{required:true}]}>
                                <DatePicker disabledDate={(current) => {
                                    return !current || current > moment().endOf('day');
                                }} format='DD-MM-YYYY' />
                            </Form.Item>
                            <Form.Item className="w-50" label="To" name={"to"} rules={[{required:true}]}>
                                <DatePicker disabledDate={(current) => {
                                    return !current || current > moment().endOf('day');
                                }} format='DD-MM-YYYY' />
                            </Form.Item>
                        </div>
                        <Form.Item className="w-50" label="Technologies" name={"technologies"} rules={[{required:true, type:'array'}]}>
                            <Select mode="tags" placeholder="eg. R, Python">

                            </Select>
                        </Form.Item>
                    </div>

                    <div className="d-flex form-item-block">
                        <Form.Item className="w-100" label="Description (Upto 100 words)" name={"description"} rules={[{required:true}]}>
                            <Input.TextArea />
                        </Form.Item>
                    </div>

                    <div className="text-right buttons">
                        <Button type="secondary" onClick={() => {
                            this.setState({item: false});
                            this.props.hide_form();
                        }}>Cancel</Button>
                        <Button className="ml-10" type="primary" htmlType="submit" loading={this.state.loading}>
                            {this.state.item ? 'Update' : '+ Add'}
                        </Button>
                    </div>
                </Form>
                
            </div>
        )
    }

    editItem = (item) => {

        this.props.display_form();

        window.setTimeout(() => {

            if(item.emp_from != '0000-00-00'){
            
                item.from = moment(item.emp_from);
            }
            if(item.emp_to != '0000-00-00'){
            
                item.to = moment(item.emp_to);
            }

            this.setState({item: item});
            this.refs.update_employment_details.setFieldsValue(item);
        });
        
    }

    remove = (item) => {

        var formData = new FormData();
        
        formData.append('account_token', this.props.account_token);
        formData.append('item_id', item.id);
        
        var that = this;

        this.setState({remove_loading: true});
        
        Api.post('freelancer/remove_employement', formData, function(data){
            
            that.setState({remove_loading: false});
            if(data.status){
                that.setState({list: data.list});
            }
        });
    }

    loadEmployementList = (account_token) => {
        var formData = new FormData();
        formData.append('account_token', account_token);
        
        var that = this;

        this.setState({loading: true});
        Api.post('freelancer/get_employment', formData, function(data){
            
            that.setState({loading: false});
            
            if(data.status == true){
            
                that.setState({list: data.list});
            }
        });
    }
}

export default Employement;
